<template>
  <div>
    <div class>
      <div class="page-actions">
        <el-button type="primary" plain @click="addReturn" style="margin-bottom: 10px">新增</el-button>
        <el-input placeholder="请输入用户ID" v-model="input" clearable></el-input>
        <el-button type="primary" @click="getList">搜索</el-button>
      </div>
      <!-- <el-button type="primary">上传Excel</el-button> -->
      <!-- <el-upload
        ref="upload"
        action="/wallet/admin/deposit/return/import/returnExcel"
        :auto-upload="false"
        :http-request="excelUpload"
        :show-file-list="false"
        accept="xlsx, xls, csv"
      >
        <el-button slot="trigger" icon="el-icon-upload" type="primary">导入文件</el-button>

        <a style="margin-left: 5px;" :href="templateUrl">
          <el-button>模板下载</el-button>
        </a>
      </el-upload>-->
      <div class="upload-box">
        <div class="upload-demo">
          <el-upload
            ref="upload"
            action="/wallet/admin/deposit/return/import/returnExcel"
            :auto-upload="false"
            :http-request="excelUpload"
            :show-file-list="true"
            accept=".xls, .xlsx, csv"
            :limit="1"
            :on-exceed="fileOnExceed"
          >
            <el-button slot="trigger" type="primary">选择文件</el-button>
            <el-button
              style="margin-left: 10px"
              type="success"
              icon="el-icon-upload"
              @click="submitUpload"
            >上传退回数据</el-button>
          </el-upload>
        </div>
          <a style="margin-left: 10px;" :href="templateUrl">
            <el-button>模板下载</el-button>
          </a>
      </div>
    </div>
    <el-tabs v-model="type" @tab-click="tabChange" style="margin-top: 15px">
      <el-tab-pane label="未处理" name="CREATE"></el-tab-pane>
      <el-tab-pane label="已审核" name="AUDIT"></el-tab-pane>
      <el-tab-pane label="已退回" name="DONE"></el-tab-pane>
      <el-tab-pane label="正在执行中" name="EXECUTING"></el-tab-pane>
      <el-tab-pane label="处理失败" name="INSUFFICIENT_FUNDS_FRO_GAS,FAIL,OTHER_ERROR"></el-tab-pane>
    </el-tabs>
    <el-table :data="returnList">
      <el-table-column label="ID" type="index" width="50"></el-table-column>
      <el-table-column label="用户ID" prop="userId"></el-table-column>
      <el-table-column label="链类型" prop="mainCoinType"></el-table-column>
      <el-table-column label="退回币种" prop="coinType"></el-table-column>
      <el-table-column label="退回数量" prop="amount"></el-table-column>
      <el-table-column label="退回hash" prop="returnHash"></el-table-column>
      <el-table-column label="充值哈希" prop="hash"></el-table-column>
      <el-table-column label="手续费哈希" prop="feeHash"></el-table-column>
      <el-table-column label="充值地址" prop="fromAddress"></el-table-column>
      <el-table-column label="退回地址" prop="returnAddress"></el-table-column>
      <el-table-column label="描述" prop="reason"></el-table-column>
      <el-table-column label="创建时间" prop="unlocking">
        <template slot-scope="scope">{{ scope.row.createTime | moment }}</template>
      </el-table-column>
      <el-table-column label="更新时间" prop="unlocking">
        <template slot-scope="scope">{{ scope.row.updateTime | moment }}</template>
      </el-table-column>
      <el-table-column label="操作" v-if="type === 'CREATE' || type === 'INSUFFICIENT_FUNDS_FRO_GAS,FAIL,OTHER_ERROR'">
        <template slot-scope="scope">
          <el-button v-if="type === 'CREATE'" type="primary" size="mini" @click="toExamine(scope.row)">审核</el-button>
          <el-button v-else type="primary" size="mini" @click="submitRetry(scope.row)">重试</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="returnTotal"
      @pageChanged="handleCurrentChange"
    ></pagination>
    <!-- 新增弹窗 -->
    <el-dialog title="新增" :visible.sync="addStatus">
      <el-form :model="addForm" :ref="addForm">
        <el-form-item label="用户ID" :label-width="formLabelWidth">
          <el-input v-model="addForm.userId"></el-input>
        </el-form-item>
        <el-form-item label="链类型" :label-width="formLabelWidth">
          <el-input v-model="addForm.mainCoinType"></el-input>
          <!-- <el-select v-model="addForm.mainCoinType" placeholder="请选择活动区域">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>-->
        </el-form-item>
        <el-form-item label="退回币种" :label-width="formLabelWidth">
          <el-input v-model="addForm.coinType"></el-input>
        </el-form-item>
        <el-form-item label="退回数量" :label-width="formLabelWidth">
          <el-input v-model="addForm.amount"></el-input>
        </el-form-item>
        <el-form-item label="充值哈希" :label-width="formLabelWidth">
          <el-input v-model="addForm.hash"></el-input>
        </el-form-item>
        <el-form-item label="手续费哈希" :label-width="formLabelWidth">
          <el-input v-model="addForm.feeHash"></el-input>
        </el-form-item>
        <el-form-item label="合约地址" :label-width="formLabelWidth">
          <el-input v-model="addForm.contractAddress"></el-input>
        </el-form-item>
        <el-form-item label="精度" :label-width="formLabelWidth">
          <el-input v-model="addForm.apiPrecision"></el-input>
        </el-form-item>
        <el-form-item label="充值地址" :label-width="formLabelWidth">
          <el-input v-model="addForm.fromAddress"></el-input>
        </el-form-item>
        <el-form-item label="退回地址" :label-width="formLabelWidth">
          <el-input v-model="addForm.returnAddress"></el-input>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="addForm.reason"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submitAdd('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 审核弹窗 -->
    <el-dialog title="审核" :visible.sync="examineStatus">
      <el-form :model="examineForm">
        <el-form-item label="币种" :label-width="formLabelWidth">
          <el-input v-model="examineForm.coinType"></el-input>
        </el-form-item>
        <el-form-item label="充值地址" :label-width="formLabelWidth">
          <el-input v-model="examineForm.fromAddress"></el-input>
        </el-form-item>
        <el-form-item label="退回地址" :label-width="formLabelWidth">
          <el-input v-model="examineForm.returnAddress"></el-input>
        </el-form-item>
        <el-form-item label="数量" :label-width="formLabelWidth">
          <el-input v-model="examineForm.amount"></el-input>
        </el-form-item>
        <el-form-item label="链类型" :label-width="formLabelWidth">
          <el-input v-model="examineForm.mainCoinType"></el-input>
          <!-- <el-select v-model="examineForm.region" placeholder="请选择活动区域">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>-->
        </el-form-item>
        <el-form-item label="合约地址" :label-width="formLabelWidth">
          <el-input v-model="examineForm.contractAddress"></el-input>
        </el-form-item>
        <el-form-item label="精度" :label-width="formLabelWidth">
          <el-input v-model="examineForm.apiPrecision"></el-input>
        </el-form-item>
        <el-form-item label="审核状态" :label-width="formLabelWidth">
          <el-select v-model="examineForm.status" placeholder="请选择审核状态">
            <el-option label="审核通过" value="AUDIT"></el-option>
            <el-option label="审核不通过" value="CREATE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="examineForm.reason"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submitExamine">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "components/pagination";
import api from "../api";
import "../store";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      input: "",
      type: "CREATE",
      accept: ["xlsx", "xls", "csv"],
      templateUrl:
        "https://alpha-dev-pub-hz.oss-accelerate.aliyuncs.com/pc/common/20220118110035/339.xlsx",
      uploadList: [],
      table: [
        {
          coinType: "12",
          unlocking: "12313131313",
          amount: "usdt",
          createTiem: 1641970006249,
          updateTiem: 1641970006249
        }
      ],
      examineStatus: false,
      addStatus: false,
      formLabelWidth: "100px",
      addForm: {},
      examineForm: {}
      // pagination: {
      //   size: 10,
      //   page: 1
      // },
      // total: 400
    };
  },
  computed: {
    ...mapState("dataCenter", ["returnList", "pagination", "returnTotal"])
  },
  methods: {
    ...mapActions("dataCenter", ["getReturnByStatus"]),
    tabChange(val) {
      this.type = val.name;
      this.getList();
    },
    excelUpload(content) {
      const data = content.file;
      api.importReturnExcel(data).then(res => {
        if (res.status === 0) {
          // 上传成功
          this.$message.success("表格上传成功");
          this.getList();
          this.uploadList = [];
        } else {
          this.$message.error("上传失败");
        }
      });
    },
    submitUpload() {
      this.uploadList = this.$refs.upload.uploadFiles;
      if (this.$refs.upload.uploadFiles.length === 0) {
        return this.$message.error("请选择文件！");
      }
      this.$refs.upload.submit();
    },
    onFileChange(file) {
      if (!file) return;
      const { raw: originFile } = file;
      const { name, size } = originFile;
      const suffix = name.split(".").pop();
      if (!this.accept.includes(suffix)) {
        this.$message.error(`只能上传${this.acceptStr}格式的文件`);
        return;
      }
      // this.readDataFromFile(originFile);
    },
    readDataFromFile(file) {
      const that = this;
      const reader = new FileReader();
      reader.onload = function(e) {
        // pre-process data
        let binary = "";
        const bytes = new Uint8Array(e.target.result);
        const length = bytes.byteLength;
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }

        /* read workbook */
        const wb = XLSX.read(binary, {
          type: "binary"
        });

        /* grab first sheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        /* generate HTML */
        that.importData = XLSX.utils.sheet_to_json(ws);
        that.dialogVisible = true;
      };
      reader.readAsArrayBuffer(file);
    },

    fileUploadSuccess() {
      /** 上传成功清除列表*/
      this.$refs.upload.clearFiles();
      this.$message.success("上传成功");
    },
    fileUploadFail() {
      this.$refs.upload.clearFiles();
      this.$message.error("上传失败");
    },
    fileOnExceed() {
      this.$message("文件最大上传为1");
    },
    // search() {
    //   api.getById({ id: this.input }).then(res => {
    //     console.log(res);
    //   });
    // },
    addReturn() {
      this.addStatus = true;
    },
    toExamine(row) {
      this.examineStatus = true;
      this.examineForm = row;
      this.examineForm.contractAddress = JSON.parse(
        row.contractInfo
      ).contractAddress;
      this.examineForm.apiPrecision = JSON.parse(row.contractInfo).apiPrecision;
    },
    handleCurrentChange(val) {
      this.getList(val);
    },
    closeDialog() {
      // this.$refs[formName].resetFields();
      this.addStatus = false;
      this.examineStatus = false;
      this.addForm = {};
      this.examineForm = {};
    },
    submitAdd(formName) {
      let data = this.addForm;
      const contractInfo = {
        contractAddress: this.addForm.contractAddress,
        coinType: this.addForm.coinType,
        apiPrecision: this.addForm.apiPrecision
      };
      data.contractInfo = JSON.stringify(contractInfo);
      delete data.contractAddress;
      delete data.contractAddress;
      api.addReturn(data).then(res => {
        if (res.status === 0) {
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.addStatus = false;
          this.getList();
        }
      });
    },
    submitExamine() {
      delete this.examineForm.contractInfo;
      api.updateReturn(this.examineForm).then(res => {
        if (res.status === 0) {
          this.$message({
            message: "修改成功",
            type: "success"
          });
          this.examineStatus = false;
          this.getList();
        }
      });
    },
    // 重试-直接通过审核
    submitRetry(row) {
      this.examineForm = row;
      this.examineForm.contractAddress = JSON.parse(
        row.contractInfo
      ).contractAddress;
      this.examineForm.apiPrecision = JSON.parse(row.contractInfo).apiPrecision;
      this.examineForm.status = 'AUDIT';
      this.submitExamine()
    },
    getList(data = {}) {
      this.getReturnByStatus({
        status: this.type,
        userId: this.input,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="less">
.upload-box {
  display: flex;
  justify-content: start;
  align-items: center;
  .upload-demo {
    position: relative;
    .el-upload-list {
      position: absolute;
      top: 32px;
    }
  }
}
</style>